(function () {
  function doesPropertyExist (property) {
    try {
      return property in window && window[property] != null;
    } catch (e) {
      return false;
    }
  }

  if (!doesPropertyExist('localStorage')) {
    Object.defineProperty(window, 'localStorage', {
      writable: true
    });
    window.localStorage = {
      _data: {},
      setItem: function (key, val) {
        this._data[key] = String(val);
        return undefined;
      },
      getItem: function (key) {
        return this._data.hasOwnProperty(key) ? this._data[key] : null;
      },
      removeItem: function (key) {
        delete this._data[key];
        return undefined;
      },
      clear: function () {
        this._data = {};
        return undefined;
      }
    };
  }
})();
